import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';
import { EVENT_TYPES, formatRange, relativeLabel, eventColor } from '../lib/format.js';
import { EMPFEHLUNG } from '../components/Empfehlung.jsx';

const URTEIL = {
  lohnt:     { label: 'Lohnt sich für dich', farbe: 'var(--verdict-strong)' },
  mitnehmen: { label: 'Kann man mitnehmen', farbe: 'var(--verdict-solid)' },
  egal:      { label: 'Für dich verzichtbar', farbe: 'var(--verdict-collection)' },
};

/**
 * "Deine Events": dieselben Events wie auf der Startseite, aber nicht nach
 * Datum sortiert, sondern danach, was sie für die eigene Sammlung bedeuten.
 */
export default function MyEventsPage() {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);

  useEffect(() => {
    api.myEvents()
      .then(setDaten)
      .catch((e) => setFehler(e.message));
  }, []);

  if (fehler) return <div className="error">{fehler}</div>;
  if (!daten) return <div className="skeleton" style={{ height: 200 }} />;

  return (
    <>
      <p className="gruppe__text">
        {daten.worth > 0
          ? `${daten.worth} von ${daten.count} kommenden Events lohnen sich für dich.`
          : 'Bei den kommenden Events ist für dich nichts Dringendes dabei.'}
        {' '}Sortiert nach Relevanz, nicht nach Datum.
      </p>

      <div className="stack">
        {daten.events.map((e) => <EventZeile key={e.slug} event={e} />)}
      </div>
    </>
  );
}

function EventZeile({ event }) {
  const u = URTEIL[event.verdict] ?? URTEIL.egal;
  const akzent = eventColor(event);

  return (
    <article className="mein-event" style={{ '--urteil-farbe': u.farbe }}>
      <div className="spread" style={{ alignItems: 'flex-start' }}>
        <div>
          <Link to={`/event/${event.slug}`} className="mein-event__titel">{event.title}</Link>
          <div className="card__meta">
            {EVENT_TYPES[event.eventType] ?? EVENT_TYPES.other} · {formatRange(event.startsAt, event.endsAt)}
          </div>
        </div>
        <div className="inline" style={{ justifyContent: 'flex-end' }}>
          <span className="badge badge--soft">{relativeLabel(event)}</span>
          <span className="badge" style={{ '--badge-color': u.farbe }}>{u.label}</span>
        </div>
      </div>

      {event.highlights.length > 0 && (
        <ul className="mein-event__gruende">
          {event.highlights.map((h) => (
            <li key={h.slug + h.name}>
              <Link to={`/pokemon/${h.slug}`} className="mein-event__mon">{h.name}</Link>
              <span className="mein-event__grund">{h.reason}</span>
            </li>
          ))}
        </ul>
      )}

      {event.highlights.length === 0 && event.summary && (
        <p className="card__summary">{event.summary}</p>
      )}

      <div className="inline mein-event__zaehler">
        {['must', 'nice', 'skip'].map((k) => (
          event.counts[k] > 0 && (
            <span className="badge badge--soft" key={k}>
              {EMPFEHLUNG[k].zeichen} {event.counts[k]}
            </span>
          )
        ))}
        <span className="badge badge--soft" style={{ borderColor: 'transparent' }}>
          <span className="text-faint">{Object.values(event.counts).reduce((a, b) => a + b, 0)} Pokémon</span>
        </span>
      </div>
    </article>
  );
}
